<template>
	<div>
		<el-dialog
			:center="true"
			:visible.sync="show"
			:close-on-click-modal="false"
			:modal="true"
			width="auto"
			height="auto"
			:append-to-body="true"
			class="dialog"
		>
			<div class="box">
				<div class="b_head">
					<span>{{ lang.invitation }}</span>
					<svg
						@click="close()"
						t="1748587270371"
						class="icon"
						viewBox="0 0 1024 1024"
						version="1.1"
						xmlns="http://www.w3.org/2000/svg"
						p-id="5023"
						width="200"
						height="200"
					>
						<path
							d="M0 0h1024v1024H0z"
							fill="#FF0033"
							fill-opacity="0"
							p-id="5024"
						></path>
						<path
							d="M240.448 168l2.346667 2.154667 289.92 289.941333 279.253333-279.253333a42.666667 42.666667 0 0 1 62.506667 58.026666l-2.133334 2.346667-279.296 279.210667 279.274667 279.253333a42.666667 42.666667 0 0 1-58.005333 62.528l-2.346667-2.176-279.253333-279.253333-289.92 289.962666a42.666667 42.666667 0 0 1-62.506667-58.005333l2.154667-2.346667 289.941333-289.962666-289.92-289.92a42.666667 42.666667 0 0 1 57.984-62.506667z"
							fill="#111111"
							p-id="5025"
						></path>
					</svg>
				</div>
				<div class="b_main" v-loading="loading">
					<div class="id_b_QrCode" v-show="url" ref="qrCodeUrl"></div>
					<div class="url_box">
						<div class="url">
							<el-input
								class="sc_fu_input"
								style="color: #000"
								disabled
								v-model="url"
							>
								<template slot="append"
									><div
										class="sc_fu_copyBtn"
										style="cursor: pointer; color: #000"
										@click.stop="copy()"
									>
										{{ lang.copy_url }}
									</div></template
								>
							</el-input>
						</div>
					</div>
				</div>
				<div class="b_bottom">
					<el-button size="small" @click="downQrCode()">{{
						lang.download_qr_code
					}}</el-button>
					<el-button size="small" type="primary" @click="close()">{{
						lang.queding
					}}</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
	data() {
		return {
			loading: false,
			show: false,
			data: null,
			url: "",
			qr: null,
		};
	},
	computed: {},
	methods: {
		open(data) {
			this.data = data;

			// this.url = data.url+'&tid='+data.id;
			// this.url = this.addTidToUrl(data.url,data.id);
			this.url = this.addParamsToUrl(data.url,{tid:data.id});
			this.loading = false;
			this.show = true;
			this.setQr();
		},
		close() {
			this.show = false;
			this.init();
		},
		init() {
			this.data = null;
			this.loading = false;
		},
		setQr() {
			this.$nextTick(() => {
				let _url = this.url;
				this.$refs.qrCodeUrl.innerHTML = "";
				new QRCode(this.$refs.qrCodeUrl, {
					text: _url, // 需要转换为二维码的内容
					width: 300,
					height: 300,
					colorDark: "#000000",
					colorLight: "#ffffff",
					correctLevel: QRCode.CorrectLevel.H,
				});
			});
		},
		copy() {
			const input = document.createElement("input");
			// 设置 display为none会导致无法复制
			// input.style.display = "none";
			// 所以只能用其他方法隐藏
			input.style.opacity = 0;
			// 为了不影响布局
			input.style.position = "fixed";
			input.style.left = "-100%";
			input.style.top = "-100%";
			input.value = this.url;
			document.body.appendChild(input);
			input.select();
			const success = document.execCommand("copy");
			document.body.removeChild(input);
			if (!success) {
				return this.$message.error("复制失败");
			} else {
				return this.$message.success("复制成功");
			}
		},
		downQrCode() {
			const link = document.createElement("a");
			link.href = this.$refs.qrCodeUrl.querySelector("img").src;
			link.download = "qrcode.png";
			// 模拟点击链接进行下载
			link.click();
		},
		addTidToUrl(url, tid) {
			if (!url || !tid) {
				return "请提供URL和tid值";
			}

			try {
				// 创建URL对象
				const urlObj = new URL(url);

				// 更新或添加tid参数
				urlObj.searchParams.set("tid", tid);

				// 返回完整的URL
				return urlObj.href;
			} catch (e) {
				// 如果URL无效（可能是相对路径），使用字符串处理
				const separator = url.includes("?") ? "&" : "?";

				// 处理带哈希的URL
				const hashIndex = url.indexOf("#");
				if (hashIndex !== -1) {
					const baseUrl = url.substring(0, hashIndex);
					const hash = url.substring(hashIndex);
					return `${baseUrl}${separator}tid=${tid}${hash}`;
				}

				return `${url}${separator}tid=${tid}`;
			}
		},
		//给地址添加参数
		addParamsToUrl(url, obj) {
			if (!url) {
				return url;
			}

			if (!obj || Object.keys(obj).length === 0) {
				return url;
			}

			let processedUrl = url;
			let result = '';

			const encodeParams = data => {
				return Object.keys(data)
					.filter(key => data[key] !== undefined && data[key] !== null)
					.map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
					.join('&');
			};

			const hashIndex = processedUrl.indexOf('#');
			if (hashIndex !== -1) {
				const baseUrl = processedUrl.substring(0, hashIndex);
				const hashPart = processedUrl.substring(hashIndex);
				const hashParamIndex = hashPart.indexOf('?');

				const newParams = encodeParams(obj);

				if (hashParamIndex !== -1) {
					// hash 部分已经包含参数
					const hashBase = hashPart.substring(0, hashParamIndex + 1);
					const hashParams = hashPart.substring(hashParamIndex + 1);

					let combinedParams = '';
					if (hashParams && newParams) {
						combinedParams = hashParams + '&' + newParams;
					} else if (hashParams && !newParams) {
						combinedParams = hashParams;
					} else if (!hashParams && newParams) {
						combinedParams = newParams;
					}

					result = baseUrl + hashBase + combinedParams;
				} else {
					// hash部分没有参数，直接?拼接
					result = baseUrl + hashPart + (newParams ? ((hashPart.indexOf('?') === -1 ? '?' : '&') + newParams) : '');
				}
			} else {
				try {
					const urlObj = new URL(processedUrl);
					Object.keys(obj).forEach(key => {
						if (obj[key] !== undefined && obj[key] !== null) {
							urlObj.searchParams.set(key, obj[key]);
						}
					});
					result = urlObj.href;
				} catch (e) {
					const hasQuery = processedUrl.includes('?');
					const newParams = encodeParams(obj);
					if (newParams) {
						result = processedUrl + (hasQuery
							? (processedUrl.endsWith('?') || processedUrl.endsWith('&') ? '' : '&') + newParams
							: '?' + newParams
						);
					} else {
						result = processedUrl;
					}
				}
			}

			return result;
		},
	},
};
</script>

<style scoped>
.dialog >>> .el-dialog {
	width: 500px !important;
	border-radius: 8px;
	padding: 0;
	background-color: #fff;
	overflow: hidden;
}

.dialog >>> .el-dialog__body {
	width: 500px !important;
	height: auto;
	flex-shrink: 0;
	padding: 0;
	box-sizing: border-box;
	overflow: auto;
}

.dialog >>> .el-dialog__header {
	display: none !important;
}

.box {
	width: 500px;
	height: auto;
	background: #fafafa;
	border-radius: 15px;
	box-shadow: 0px 6px 30px 5px rgba(0, 0, 0, 0.05),
		0px 16px 24px 2px rgba(0, 0, 0, 0.04), 0px 8px 10px -5px rgba(0, 0, 0, 0.08);
}

.b_head {
	width: 100%;
	height: 50px;
	border-radius: 15px 15px 0 0;
	background: #fff;
	display: flex;
	align-items: center;
	justify-content: space-between;
	box-sizing: border-box;
	padding: 0 20px;
}

.b_head > span {
	font-size: 18px;
	font-weight: bold;
	color: #000;
}

.b_head > img {
	width: 20px;
	height: 20px;
	cursor: pointer;
}

.b_head > svg {
	width: 20px;
	height: 20px;
	cursor: pointer;
}

.b_main {
	width: 100%;
	height: auto;
	background: #fafafa;
	padding: 20px 20px 0 20px;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.b_bottom {
	width: 100%;
	height: 70px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	box-sizing: border-box;
	padding: 0 20px;
}

.id_b_QrCode {
	width: 300px;
	height: 300px;
	margin: 40px 0;
	background-color: #000;
}

.url_box {
	width: 100%;

	margin-bottom: 20px;
}

.url_box > .url {
	width: 100%;
	display: flex;
	align-items: center;
	/*border: 1px solid #e7e7e7;*/
	border-radius: 4px;
	height: 35px;
	padding: 0 7px;
	box-sizing: border-box;
}

.url_box > .url > span {
	font-size: 16px;
	color: #000000;
}

.url_box > .url > span:nth-child(1) {
	width: 100%;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.url_box > .url > span:nth-child(2) {
	margin-left: auto;
	border-left: 1px solid #e7e7e7;
	padding-left: 7px;
	cursor: pointer;
	min-width: fit-content;
}

.url_box > .title,
.qrcode_box > .title {
	font-size: 16px;
	font-weight: 700;
	margin-bottom: 10px;
}

.id_bottom {
	display: flex;
	margin-top: 20px;
	justify-content: flex-end;
}

.sc_fu_input >>> .el-input__inner {
	color: #000 !important;
	cursor: default !important;
}
</style>
